import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { getIconStyles as r } from "../styles.js";
const c = (e) => /* @__PURE__ */ i(
  "svg",
  {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3698_14300)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.5 6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5V12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12V6.5ZM13.625 17C13.625 17.8975 12.8975 18.625 12 18.625C11.1025 18.625 10.375 17.8975 10.375 17C10.375 16.1025 11.1025 15.375 12 15.375C12.8975 15.375 13.625 16.1025 13.625 17Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3698_14300", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.0234375 -0.00012207)"
        }
      ) }) })
    ]
  }
);
export {
  c as SolidCircleAlertIcon
};
//# sourceMappingURL=SolidCircleAlertIcon.js.map
